import HelpDeskLateral from './HelpDeskLateral';

export default HelpDeskLateral;
